import { userType } from "../../DTO";
import { Api } from "../api";

export const SendClinicPatientInvitation = (
    user: userType,
    profileId: number,
) => {
    return new Promise<{ data: any }>((resolve, reject) => {
        const api = new Api({
            method: "post",
            path: `clinic/patients/${profileId}/send-invitation`,
            header: {
                Authorization: `Bearer ${user.access_token}`,
            },
        });
        return api
            .call()
            .then((data: any) => resolve({ data: data.data }))
            .catch((err: any) => reject(err));
    });
};
